import addRoute from '@/router/add-route';

const SearchResults = () => import('@/modules/search/search-results.vue');

const searchResults = [
    addRoute({
        name: 'search-results',
        path: '/search',
        component: SearchResults,
    }),
];

export default searchResults;
